/**
 * Rótulos da troca "Apuração · Linha do tempo" (ORD-F-026), num módulo leve: a troca fica no JS crítico do site ao vivo e
 * do replay, e `copy/commentary.ts` (o catálogo das frases) fica fora do crítico do ao vivo.
 *
 * APROVADO pelo responsável (§8 de 17/10, 08h43, c11970a4; ORD-F-036). A troca se chama "Apuração · Linha do tempo": "Comentários" repetia a aba da coluna
 * direita no computador.
 */
import { interpolate } from './strings';

export const SCREEN_STRINGS = {
  'timeline.toggle.aria': 'Escolher a tela',
  'timeline.toggle.results': 'Apuração',
  'timeline.toggle.comments': 'Linha do tempo',
} as const;
export type ScreenKey = keyof typeof SCREEN_STRINGS;

export function tScreen(key: ScreenKey): string {
  return interpolate(key, SCREEN_STRINGS[key]);
}
